import styled from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { textStyles } from "../../../shared/textStyles";

export const ItemContainer = styled.label`
  all: initial;

  ${tombac.text({
    color: "inherit",
    fontSize: 14,
  })}

  cursor: default;
  display: block;
  flex: 1;
  margin: ${tombac.unit(0, 1)};
  min-width: max-content;
  overflow: hidden;

  ${propStyling}
  ${textStyles}
`;
